module.exports = __webpack_public_path__ + "static/img/acne_scars-01.0a03de6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/acne_scars-01.jpg
// module id = 243
// module chunks = 1